import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { Reveal, SectionHeading } from "./Reveal";
import { prefillMotivo } from "../config/site";

const faqs = [
  {
    q: "¿Cuándo es recomendable acudir a un gabinete de psicopedagogía?",
    a: "Cuando observamos que un niño, una niña o un adolescente tiene dificultades para aprender, concentrarse, organizarse o afrontar sus tareas escolares, puede ser útil consultar con un profesional. No es necesario esperar a que las dificultades se agraven ni contar con un diagnóstico previo. Una valoración individualizada nos ayudará a comprender qué está ocurriendo e identificar estrategias adaptadas a sus necesidades. Si tienes dudas, escríbeme y hablamos sobre vuestra situación en una primera consulta.",
  },
  {
    q: "¿En qué consiste una evaluación psicopedagógica?",
    a: "La evaluación psicopedagógica es un proceso individualizado que nos ayuda a comprender cómo aprende cada persona, identificar sus fortalezas y conocer las dificultades que pueden estar interfiriendo en su aprendizaje. Para ello, puedo combinar entrevistas con la familia, observación, análisis de la información académica y aplicación de pruebas estandarizadas, cuando resulte adecuado. A partir de la información recogida, elaboro una valoración del perfil de aprendizaje y oriento las medidas de intervención y las estrategias educativas más adecuadas para responder a sus necesidades. El objetivo no es etiquetar, sino comprender, orientar y ofrecer herramientas que favorezcan el desarrollo y el aprendizaje de cada niño, niña o adolescente.",
  },
  {
    q: "¿Qué diferencia hay entre apoyo escolar y reeducación pedagógica?",
    a: "El apoyo escolar se centra en repasar los contenidos de las asignaturas. La reeducación pedagógica va un paso más allá: trabaja los procesos que intervienen en el aprendizaje —como la atención, la lectura, la escritura, el razonamiento o las estrategias de estudio— para favorecer una mayor autonomía en el aprendizaje.",
  },
  {
    q: "¿Cómo puedo saber qué servicio necesita mi hijo/a?",
    a: "No hace falta que lo tengas claro antes de contactar. En la primera consulta escucho vuestra situación, resuelvo dudas y valoro qué servicio puede ser el más adecuado. Cada persona es única y la intervención se adapta a sus necesidades.",
  },
  {
    q: "¿Cómo se desarrolla la primera consulta?",
    a: "Es un primer encuentro para conocernos, escuchar vuestras inquietudes y comprender la situación. Hablaremos sobre las necesidades de vuestro hijo o hija y os explicaré cómo puedo ayudaros. Después, decidiréis con total libertad si queréis comenzar.",
  },
  {
    q: "¿Dónde está ubicado ATENTO?",
    a: "Estoy en el Centro Comercial La Plaza, en la planta alta, local 23, en la calle Ayala, en Chiclana de la Frontera (Cádiz). Atiendo con cita previa para ofrecer un acompañamiento personalizado. Puedes contactar conmigo por WhatsApp o a través del formulario de contacto.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="py-20 lg:py-28 bg-cream/60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <SectionHeading
              eyebrow="Preguntas frecuentes"
              title="Resolvemos tus dudas con claridad"
              intro="Estas son las preguntas que más a menudo me hacen las familias. Si la tuya no está aquí, estaré encantada de responderte."
            />
            <Reveal delay={0.2}>
              <div className="mt-9 bg-white border border-atento-blue/10 rounded-2xl p-7">
                <p className="font-serif text-xl text-atento-blue font-semibold leading-snug">
                  ¿No encuentras tu respuesta?
                </p>
                <p className="mt-3 text-sm leading-relaxed text-charcoal/65">
                  Cada situación es particular. Escríbeme y lo vemos juntos, sin
                  compromiso.
                </p>
                <button
                  onClick={() => prefillMotivo("Hola Lidia, tengo una duda que no aparece en las preguntas frecuentes de la web.")}
                  data-testid="faq-cta-button"
                  className="mt-5 font-accent font-semibold text-sm text-atento-blue border-b-2 border-sage hover:border-atento-blue pb-0.5 transition-colors cursor-pointer"
                >
                  Hacer mi consulta
                </button>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <Reveal delay={0.1}>
              <Accordion type="single" collapsible className="space-y-4" data-testid="faq-accordion">
                {faqs.map((f, i) => (
                  <AccordionItem
                    key={i}
                    value={`faq-${i}`}
                    data-testid={`faq-item-${i}`}
                    className="bg-white rounded-2xl border border-atento-blue/10 px-6 sm:px-7 overflow-hidden data-[state=open]:border-sage/40 data-[state=open]:shadow-[0_8px_28px_rgba(27,59,111,0.07)] transition-all duration-300"
                  >
                    <AccordionTrigger
                      data-testid={`faq-trigger-${i}`}
                      className="text-left font-accent font-semibold text-base sm:text-lg text-atento-blue py-6 hover:no-underline hover:text-atento-dark [&[data-state=open]>svg]:text-sage-dark"
                    >
                      {f.q}
                    </AccordionTrigger>
                    <AccordionContent
                      data-testid={`faq-content-${i}`}
                      className="text-sm sm:text-base leading-relaxed text-charcoal/70 pb-6"
                    >
                      {f.a}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
